<template>
    <div class="outer">

        <el-dialog width="55%" destroy-on-close :title="dialogTitle" :close-on-click-modal="false" :visible="claimVisible"
            @close="closeClaimDialog">

            <el-card style="margin-bottom: 30px">
                <div class="flex-space-between listTop" slot="header">
                    <span>申领单基本信息</span>
                </div>
                <el-form ref="claimForm" :model="claimForm" label-width="110px">
                    <el-row :gutter="100">
                        <el-col :span="12">
                            <el-form-item label="申领用途类型" class="queryCol">
                                <el-select style="width: 100%" v-model="claimForm.usageType" @change="usageTypeChange" disabled>
                                    <el-option value="1" label="项目用"></el-option>
                                    <el-option value="2" label="部门用"></el-option>
                                    <el-option value="4" label="办公(用品)用"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="项目名称" v-show="claimForm.usageType === '1'">
                                <el-select style="width: 100%" v-model="claimForm.chanceId" 
                                    disabled placeholder="无">
                                    <el-option v-for="(item, i) in projectList" :key="i" :label="item.name"
                                        :value="item.code"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="100">
                        <el-col :span="24">
                            <el-form-item label="申领理由" >
                                <el-input disabled v-model="claimForm.applyReason" type="textarea" placeholder="请输入">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>

            </el-card>

            <el-card style="margin-bottom: 30px"
                v-if="claimForm.tbApplyGoodsListModelList.length !== 0 && dialogType !== 'Rapproval'">
                <div class="flex-space-between listTop" slot="header">
                    <span>申领的货物</span>
                </div>
                <el-table :row-style="{ height: '50px' }" style="width: 100%;" border :data="claimForm.tbApplyGoodsListModelList">
                    <el-table-column align="center" label="货物名称" prop="goodsName">
                    </el-table-column>
                    <el-table-column align="center" label="货物类别" prop="goodsClassName">
                    </el-table-column>
                    <el-table-column align="center" label="货物型号" prop="goodsType">
                    </el-table-column>
                    <el-table-column align="center" label="货物配置" prop="goodsConfig">
                        <template slot-scope="scope"> 
                            <el-popover trigger="hover" placement="top" width="300">
                                <p>{{ scope.row.goodsConfig }}</p>
                                    <div slot="reference">
                                    <p size="medium" style="white-space: nowrap;overflow: hidden;text-overflow:ellipsis;">{{ scope.row.goodsConfig}}</p>
                                </div>
                            </el-popover>        
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="平均价格(元)" prop="price">
                    </el-table-column>
                    <el-table-column align="center" label="当前库存总数量" prop="storeGoodsNum">
                    </el-table-column>
                    <el-table-column align="center" label="本次申领数量" prop="goodsNum">
                        <template slot-scope="scope">
                            <el-input style="width: 100px" v-if="scope.row.isEdit" v-model="scope.row.goodsNum"
                                placeholder="请输入"></el-input>
                            <span v-else>{{ scope.row.goodsNum }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="货物单位" prop="goodsUnit">
                    </el-table-column>
                </el-table>
            </el-card>

            <el-card v-if="claimForm.tbXzRequestGoodsListModelList.length !== 0">
                <div class="flex-space-between listTop" slot="header">
                    <span>请购的货物</span>
                </div>
                <el-table
                border
                :row-style="{ height: '50px' }"
                style="width: 100%"
                :data="claimForm.tbXzRequestGoodsListModelList">
                    <el-table-column align="center" label="货物名称" prop="goodsName">
                    </el-table-column>
                    <el-table-column align="center" label="货物类别" prop="goodsClassName">
                    </el-table-column>
                    <el-table-column align="center" label="货物型号" prop="goodsType">
                    </el-table-column>
                    <el-table-column align="center" label="货物配置" prop="goodsConfig">
                        <template slot-scope="scope"> 
                            <el-popover trigger="hover" placement="top" width="300">
                                <p>{{ scope.row.goodsConfig }}</p>
                                    <div slot="reference">
                                    <p size="medium" style="white-space: nowrap;overflow: hidden;text-overflow:ellipsis;">{{ scope.row.goodsConfig}}</p>
                                </div>
                            </el-popover>        
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="货物单位" prop="goodsUnit">
                    </el-table-column>
                    <el-table-column align="center" label="货物品牌" prop="goodsBrand">
                    </el-table-column>
                    <el-table-column align="center" label="状态" prop="requestState">
                        <template slot-scope="scope">
                            <el-tag :type="RstateTagType(scope.row.requestState)">{{ RstateTagName(scope.row.requestState) }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="请购数量" prop="goodsNum">
                    </el-table-column>
                    <el-table-column align="center" label="操作" prop="operate" v-if="dialogType === 'Rapproval'">
                        <template slot-scope="scope">
                            <el-button type="primary" icon="el-icon-s-claim"
                                @click="requestApproval(scope.row)">审批</el-button>
                        </template>
                    </el-table-column>

                </el-table>
            </el-card>

            <span slot="footer" class="dialog-footer" v-if="dialogType === 'Capproval'">
                <el-button type="danger" @click="approvalClaim(2)">驳回</el-button>
                <el-button type="primary" @click="approvalClaim(1)">通过</el-button>
            </span>

            <span slot="footer" class="dialog-footer" v-if="dialogType === 'outbounce'">
                <el-button type="primary" @click="openOutVisable">全部出库</el-button>
            </span>
        </el-dialog>

        <el-dialog width="35%" :close-on-click-modal="false" title="出库" :visible="outVisable" @close="closeOutDialog">
            <el-form ref="outForm" :model="outForm" :rules="outRules" label-width="130px" style="width: 89%;">

               <el-form-item
                label="接收人部门名称"
                prop="departmentCode"
                label-width="130px"
                required
                >
                    <treeselect
                        :disable-branch-nodes="true"
                        v-model="outForm.departmentCode"
                        :options="deptOptions"
                        :clearable="false"
                        :default-expand-level="2"
                        :normalizer="normalizer"
                        placeholder="请选择部门名称"
                        @select="handleSelect"
                    />
                </el-form-item>
                <el-form-item
                label="接收人名称"
                prop="receiverUserId"
                label-width="130px"
                required
                >
                    <el-select
                    class="userSelect"
                    style="width: 100%"
                    v-model="outForm.receiverUserId"
                    placeholder="请选择"
                    :popper-append-to-body="false"
                    clearable
                    >
                        <el-option
                        v-for="item in CeOptions"
                        :key="item.id"
                        :label="item.trueName"
                        :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注" prop="remarks">
                    <div class="flex-center">
                        <el-input style="width: 100%" type="textarea" v-model="outForm.remarks"
                            placeholder="请输入"></el-input>
                    </div>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button @click="closeOutDialog">取 消</el-button>
                <el-button type="primary" :loading="btnLoading" @click="submitOutOrder">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 顶部搜索框 -->
        <div class="topSearch">
            <el-form class="queryRow" inline :model="queryForm">
                <el-form-item label="项目名称" class="queryCol">
                    <el-select v-model="queryForm.chanceId" clearable filterable @change="onSearch" @clear="onSearch">
                        <el-option v-for="(item, i) in projectList" :key="i" :label="item.name"
                            :value="item.code"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="申领用途类型" class="queryCol">
                    <el-select v-model="queryForm.usageType" clearable @change="onSearch" @clear="onSearch">
                        <el-option :value="1" label="项目用"></el-option>
                        <el-option :value="2" label="部门用"></el-option>
                        <el-option :value="4" label="办公(用品)用"></el-option>
                    </el-select>
                </el-form-item>
                
                <el-form-item label="申领单状态" class="queryCol">
                    <el-select v-model="queryForm.applyState" @change="onSearch">
                        <el-option :value="3" label="审批完成"></el-option>
                        <el-option :value="5" label="已领用"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="申领单号" class="queryCol">
                    <el-input v-model="queryForm.applyNo" placeholder="请输入申领单号" clearable  @clear="onSearch"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="onSearch">查询</el-button>
                </el-form-item>
            </el-form>
        </div>

        <el-table :row-style="{ height: '50px' }" v-loading="loading" :cell-class-name="cellClassName" border class="table" style="width: 100%;height: 70vh;overflow: auto;"
            :data="claimList">
            <template slot="empty">
                <el-empty :image-size="150"></el-empty>
            </template>
            <el-table-column type="expand" label=" " width="50">
                <template slot-scope="props">
                    <el-descriptions title="项目信息" class="demo-table-expand" :column="1">
                        <el-descriptions-item label="商机号">{{ props.row.chanceId }}</el-descriptions-item>
                        <el-descriptions-item label="商机名称">{{ props.row.chanceName }}</el-descriptions-item>
                    </el-descriptions>
                </template>
            </el-table-column>
            <el-table-column align="center" label="申领单编号" prop="applyNo" width="130">
            </el-table-column>
            <el-table-column align="center" label="申领用途类型" prop="usageTypeName">
            </el-table-column>
            <el-table-column align="center" label="申领人" prop="createUserName">
            </el-table-column>
            <el-table-column align="center" label="申领人部门" prop="departmentName">
            </el-table-column>
            <el-table-column align="center" label="申领理由" prop="applyReason">
            </el-table-column>
            <el-table-column align="center" label="申领单状态" prop="applyStateName">
                <template slot-scope="scope">
                    <el-tag :type="stateTagType(scope.row.applyState)">{{ scope.row.applyStateName }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column align="center" label="申请时间" prop="createTime" min-width="130" :formatter="dateTimeTwoLine" class-name="cell-two-line">
            </el-table-column>
            <el-table-column align="center" label="操作" prop="operate">
                <template slot-scope="scope">
                    <el-button type="text" class="Primary-text" icon="el-icon-document"
                        @click="openClaimVisible(scope.row, 'detail')">详情</el-button>
                    <el-button type="text" class="Primary-text" icon="el-icon-truck" v-if="scope.row.applyState == 3"
                        @click="openClaimVisible(scope.row, 'outbounce')">出库</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="pageination">
            <el-pagination @size-change="onSizeChange" @current-change="onCurrentChange" :total="total"
                :page-size="queryForm.limit" :page-sizes="[10, 20, 30, 40, 50, 100]" :current-page="queryForm.page"
                background layout="sizes, prev, pager, next, jumper, ->, total">
            </el-pagination>
        </div>
        
    </div>
</template>
<script>
import { getUserSelectByPage } from "@/api/plat/PlatStaff";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import {
    getApplyList,
    queryApplyUse,
    getApprovedList,
    applyApprovalReject,
    addOutStore, // 出库
} from '@/api/goods/applyForm.js';
import { getProjects, getAllProject } from '@/api/work/WorkOrderList.js';
import { isSales } from "@/views/goods/permission.js";
export default {
    data() {
        var checkGoodsNum = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('请输入货物数量'));
            }
            if (value && (value <= 0 || value.toString().includes('.'))) {
                callback(new Error('请输入正整数'));
            } else {
                callback();
            }
        }
        return {
            btnLoading: false, // 提交按钮loading
            roleId: sessionStorage.getItem('uid'),
            dialogTitle: '',
            approvalForm: {},
            activeName: '1',
            requestGoodsTitle: '', // 请购单货物标题  
            tableKey: 0,
            total: 0, // 表格总数
            loading: false,
            classOptions: [], // 货物分类列表
            isXiaos: isSales(), // 销售类角色（roleId 2、3）可选项目用/商机
            queryForm: {
                createUserId: '',
                func: 2,
                chanceId: '',
                usageType: '',
                applyState: 3,
                page: 1,
                limit: 10,
            },// 查询表单
            projectList: [], //项目列表
            claimVisible: false, // 申领单弹窗显隐
            buyRequestGooodsVisable: false, // 请购单货物列表
            checkInventoryVisible: false, // 选中库存弹窗显隐
            buyRequestGooodsForm: {
                goodsName: '',
                goodsBrand: '',
                goodsType: '',
                goodsConfig: '',
                goodsNum: '',
                remarks: '',
            }, // 请购单货物表单
            buyRequestGooodsRules: {
                goodsName: [
                    { required: true, message: '请输入货物名称' },
                ],
                goodsBrand: [
                    { required: true, message: '请输入货物品牌' },
                ],
                goodsType: [
                    { required: true, message: '请输入货物型号' },
                ],
                goodsConfig: [
                    { required: true, message: '请输入货物配置' },
                ],
                goodsNum: [
                    { validator: checkGoodsNum, type: 'change' },
                ],
            }, // 请购单货物表单
            claimForm: {
                usageType: '',
                chanceId: '',
                applyReason: '',
                tbApplyGoodsListModelList: [],
                tbXzRequestGoodsListModelList: [],
            }, // 申领单填写表单
            claimRules: {
                usageType: [
                    { required: true, message: '请选择申领用途类型' },
                ],
                applyReason: [
                    { required: true, message: '请选择申领理由' },
                ]
            }, // 申领单表单验证
            claimList: [], // 申领单列表
            dialogType: '', // 弹窗类型
            deptOptions: [], // 部门列表
            CeOptions: [], // 货物提供人下拉数据
            outForm: {
                receiverUserId: '',
                remarks: '',
            }, // 出库表单
            outRules: {
                departmentId: [
                    { required: true, message: '请选择接收人部门' },
                ],
                receiverUserId: [
                    { required: true, message: '请选择接收人' },
                ],
            }, // 出库表单验证
            outVisable: false
        }
    },
    async created() {
        if (this.$route.params.applyNo) {
            this.queryForm.applyNo = this.$route.params.applyNo;
            this.queryForm.applyState = 5;
        }
        await this.getApplyList();
        this.isXiaos ? this.getProjects() : this.getAllProject();
        let deptArr = await this.getDimTableDeptByIds([213, 214, 216]);
        this.deptOptions = deptArr.data.concat([]);
    },
    components: {
        Treeselect,
    },
    computed: {
        
    },
    watch: {

    },
    methods: {
        submitOutOrder(){
            this.$refs.outForm.validate((valid) => {
                if (!valid) return;
                const doSubmit = () => {
                    this.btnLoading = true;
                    addOutStore({
                        receiverUserId: this.outForm.receiverUserId,
                        remarks: this.outForm.remarks, 
                        applyNo: this.claimForm.applyNo,
                    }).then(res => {
                        this.btnLoading = false;
                        if (res.code == 200) {
                            this.$alert('出库单号: ' + res.result, '出库成功!', {
                                confirmButtonText: '确定',
                            })
                            this.queryForm.applyState = 5;
                            this.getApplyList();
                            this.outVisable = false;
                            this.claimVisible = false;
                        }
                    })
                };
                // 库存不足提示但不强制拦截（文档 8.3.2 / Q5）
                const insufficient = (this.claimForm.tbApplyGoodsListModelList || []).filter(item => item.goodsNum > item.storeGoodsNum);
                if (insufficient.length > 0) {
                    this.$confirm(`以下货物库存不足，建议采购：${insufficient.map(i => i.goodsName).join('、')}，是否继续出库？`, '库存不足提示', {
                        confirmButtonText: '继续出库',
                        cancelButtonText: '取消',
                        type: 'warning',
                    }).then(doSubmit).catch(() => {});
                } else {
                    doSubmit();
                }
            });
        },
        /** 转换部门数据结构 */
        normalizer(node) {
            if (node.children && !node.children.length) {
                delete node.children;
            }
            return {
                id: node.code,
                label: node.name,
                children: node.children,
            };
        },
        // 节点单击事件
        async handleSelect(node, instanceId) {
            this.outForm.receiverUserId = '';
            let { data } = await getUserSelectByPage({
                condition: {
                    departmentId: node.id,
                },
                limit: 9999,
                page: 1,
            });
            this.CeOptions = data.records;
        },
        closeOutDialog(){
            this.$refs.outForm.resetFields();
            this.outForm = {
                receiverUserId: '',
                remarks: '',
            };
            this.outVisable = false;
        },
        RstateTagType(requestState){
            switch (requestState) {
                case '1':
                    return '';
                    break;
                case '2':
                    return 'success';
                    break;
                case '3':
                    return 'danger';
                    break;
            }

        },
        RstateTagName(requestState){
            switch (requestState) {
                case '1':
                    return '待审批';
                    break;
                case '2':
                    return '审批完成';
                    break;
                case '3':
                    return '审批驳回';
                    break;
                case '4':
                    return '已入库';
                    break;
            }

        },
        // 打开申领单
        async openClaimVisible(row,type){
            this.dialogType = type;
            if(type === 'Capproval'){
                this.dialogTitle = '审批申领单';
            } else if(type === 'Rapproval'){
                this.dialogTitle = '审批请购单';
            } else if(type === 'outbounce'){
                
                this.dialogTitle = '申领单出库';
            } else{
                this.dialogTitle = '申领单详情';
            }
            this.queryApplyUse(row);
            this.claimVisible = true;
        },
        async openOutVisable(){
            await this.handleSelect({id: this.claimForm.departmentId});
            this.outForm.departmentCode = this.claimForm.departmentCode;
            this.outForm.receiverUserId = this.claimForm.createUserId;
            this.outVisable = true;
        },
        cellClassName({ row, column }) {
            if(column.type === 'expand' && row.usageType !== '1'){
                return 'hidden-row'
            }
            return ''
        },
        // 请购单审批
        requestApproval(row){
            this.$prompt('请输入审批意见',
             '请购审批', {
                confirmButtonText: '通过',
                cancelButtonText: '驳回',
                inputPattern: /[^ \x20]+/,
                inputErrorMessage: '审批意见不能为空!'
            }).then(({ value }) => {
                applyApprovalReject({
                    approvalType: 5,
                    applyCode: row.requestNo,
                    approvalResult: 1,
                    opinion: value
                }).then(res => {
                    if(res.code === 200){
                        this.$message({
                            type: 'success',
                            message: '操作成功',
                        });
                        this.queryApplyUse(this.claimForm);
                    }
                })
            }).catch((value) => {
                applyApprovalReject({
                    approvalType: 5,
                    applyCode: row.requestNo,
                    approvalResult: 2,
                    opinion: value
                }).then(res => {
                    if(res.code === 200){
                        this.$message({
                            type: 'success',
                            message: '操作成功',
                        });
                        this.queryApplyUse(this.claimForm);
                    }
                })
            });
        },
        // 审核采购单
        approvalClaim(approvalResult) {
            let promptTitle = (approvalResult == 1 ? "审批通过" : "审批驳回");
            this.$prompt('请输入审批意见',
             promptTitle, {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputValue: approvalResult == 1 ? '同意' : '',
                inputPattern: /[^ \x20]+/,
                inputErrorMessage: '审批意见不能为空!'
            }).then(({ value }) => {
                applyApprovalReject({
                    approvalType: 4,
                    applyCode: this.claimForm.applyNo,
                    approvalResult,
                    opinion: value
                }).then(res => {
                    if(res.code === 200){
                        this.$message({
                            type: 'success',
                            message: '操作成功',
                        });
                        this.queryForm.func = 1;
                        this.getApplyList();
                        this.claimVisible = false;
                    }
                })
            })
        },
        stateTagType(state) {
            switch (state) {
                case '1':
                    return 'warning';
                    break;
                case '2':
                    return 'info';
                    break;
                case '3':
                    return '';
                    break;
                case '4':
                    return 'danger';
                    break;
                case '5':
                    return 'success';
                    break;
            }
        },
        // 关闭申领单弹窗
        closeClaimDialog() {
            this.$refs.claimForm.resetFields();
            this.claimForm.tbApplyGoodsListModelList = [];
            this.claimForm.tbXzRequestGoodsListModelList = [];
            this.claimVisible = false;
        },

        // 查询申领单货物明细
        queryApplyUse(row) {
            queryApplyUse({ applyNo: row.applyNo }).then(res => {
                if (res.code === 200) {
                    this.claimForm = res.result;
                }
            })
        },

        usageTypeChange(e) {
            this.claimForm.chanceId = '';
        },
        // 当每页条数变化
        onSizeChange(e) {
            this.queryForm.page = 1;
            this.queryForm.limit = e;
            this.getApplyList();
        },
        // 当页码发生变化时
        onCurrentChange(e) {
            this.queryForm.page = e;
            this.getApplyList();
        },
        onSearch() {
            this.queryForm.page = 1;
            this.getApplyList();
        },
        // 获取申领单列表
        getApplyList() {
            this.loading = true;
            getApplyList(this.queryForm).then(res => {
                if (res.code === 200) {
                    this.total = res.count;
                    this.claimList = res.data;
                    this.loading = false;
                }
            })
        },
        // 获取所有项目列表
        getProjects() {
            getProjects().then(res => {
                if (res.code === 200) {
                    this.projectList = res.data
                }
            })
        },
        getAllProject() {
            getAllProject().then(res => {
                if (res.code === 200) {
                    this.projectList = res.result
                }
            })
        }

    },
}
</script>

<style lang="scss" scoped>
.outer {

    .listTop{
        margin-bottom: 15px;
        font-size: 15px;
        font-weight: 450;
    }

    .demo-table-expand {
        font-size: 0;
        margin-left: 65px;

        ::v-deep .el-form-item__label {
            width: 90px;
            color: #99a9bf;
        }

        .el-form-item {
            margin-right: 0;
            margin-bottom: 0;
            width: 50%;
        }
    }

    .clearfix {
        display: flex;
        justify-content: flex-end;
    }

    .el-form-item {
        margin-right: 20px;
    }

    .pageination {
        display: flex;
        justify-content: flex-end;
        margin-top: 5px;
    }

    .topSearch {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
    }

    .queryRow {
        overflow: hidden;
        display: flex;

        .queryName {
            width: 300px;
            margin-right: 10px;
        }

        .dataPicker {
            margin-right: 10px;
        }
    }

    .detailTable {
        ::v-deep .el-checkbox__input {
            &.is-checked {
                .el-checkbox__inner {
                    background-color: #409EFF;
                    border-color: #409EFF;
                }
            }
        }
    }

    .table {

        ::v-deep .hidden-row  .cell{
            visibility: hidden;
        }

        ::v-deep .el-tooltip__popper {
            font-size: 14px;
            max-width: 40%
        }


        ::v-deep .el-table__cell {
            >:empty::before {
                content: '--';
                color: gray;
            }
        }
    }
}
</style>
